import { RestCodes } from '../common/enums/common.enums';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';

export type MessageType = 'success' | 'info' | 'error' | 'warning';

export const createToastNotification = (
  messageType: MessageType,
  message: string[] | string,
  error?: any
) => {
  const messageText = message;

  if (messageType === 'success') {
    return toast.success(messageText);
  } else if (messageType === 'info') {
    return toast.info(messageText);
  }else if(messageType==='warning'){
    return toast.warning(messageText);
  } else {
    if (error?.response?.status === RestCodes.Unauthorized) {
      return;
    }
    toast.error(`${messageText}`);
  }
};

export const decodeUserFromToken = (token: string) => {
  try {
    const decodedToken: any = jwtDecode(token);
    return decodedToken || null;
  } catch (error) {
    return undefined;
  }
};

export const formatDate = (date: string) => {
  const dateString = new Date(date);
  const day = dateString.getDate().toString().padStart(2, '0');
  const month = (dateString.getMonth() + 1).toString().padStart(2, '0');
  const year = dateString.getFullYear();

  return `${year}-${month}-${day}`;
};

//@ts-ignore
export const toQueryString = (params) => {
  return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null)
      //@ts-ignore
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
}
